import { z } from 'zod'

/** Planner后端接口说明（2026-10-10）；仅概览、每日景点活动与提醒。 */
export const TRAVEL_PLAN = 'travel_plan'
const text = z.string().min(1).max(2000)
const tips = z.array(text).max(20).default([])
const date = z.iso.date().nullable().default(null)

const activitySchema = z.looseObject({
  period: text,
  place_name: text,
  place_type: text,
  description: text,
  recommended_duration: text,
  reason: text,
  transport_to_next: text.or(z.literal('')).nullable().default(null),
  tips,
})

export const travelPlanCardSchema = z.looseObject({
  type: z.literal(TRAVEL_PLAN),
  schema_version: z.literal('travel_plan_v1'),
  id: z.string().min(1),
  // 已有合法结构时不依赖历史降级文本。
  fallback_text: z.string().default(''),
  plan: z
    // strip 掉历史规划中的旧模块；新增字段也不阻断已知内容展示。
    .object({
      title: text,
      summary: text,
      destination: text,
      duration_days: z.number().int().min(1).max(14),
      start_date: date,
      assumptions: z.array(text).max(20),
      days: z
        .array(
          z.looseObject({
            day: z.number().int().min(1).max(14),
            date,
            theme: text,
            activities: z.array(activitySchema).min(1).max(8),
            daily_tips: tips,
          }),
        )
        .min(1)
        .max(14),
      tips,
    })
    .refine(
      (plan) =>
        plan.days.length === plan.duration_days &&
        plan.days.every((day, index) => day.day === index + 1),
    ),
})

export type TravelPlanCard = z.infer<typeof travelPlanCardSchema>

/** 去重仅适用于有稳定 id 的规划卡；不能折叠新任务的不同结果。 */
export function travelPlanId(card: { type: string; [key: string]: unknown }): string | null {
  if (
    card.type === 'planner_report_ref_v2' &&
    typeof card.version_id === 'string' &&
    card.version_id
  )
    return `planner-v2:${card.version_id}`
  return card.type === TRAVEL_PLAN && typeof card.id === 'string' && card.id.length > 0
    ? card.id
    : null
}
